/*
 * @Author: Teemo Ding
 * @Date: 2021-07-05 16:23:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-05 16:15:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/hooks/aliasIdHooks.tsx
 */
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { useHistory } from 'react-router';

import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const aliasIdHooks = (getUuid) => {
  const _h = useHistory();

  const aliasUuidSlice: any = useSelector(getUuid());
  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
    aliasUuid: string;
  } = useParams();
  const { aliasUuid, salesChannelProductUuid, saleChannelUuid } = _params;
  useAfterDidMountEffect(() => {
    if (aliasUuidSlice !== aliasUuid) {
      _h.replace(
        `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}/${aliasUuidSlice}`,
      );
    }
  }, [aliasUuidSlice]);
};
export { aliasIdHooks };
